import { useState, JSX } from "react";
import Skeleton from "react-loading-skeleton";

type ImageProps = {
  src: string;
  alt: string;
  id?: string;
  className?: string;
  style?: React.CSSProperties;
  height?: string | number;
  width?: string | number;
  circle?: boolean;
  loading?: "lazy" | "eager" | undefined;
  loadedCallback?: () => void;
};

export default function ImageV2({
  src,
  alt,
  id,
  className,
  style,
  height = "100%",
  width = "100%",
  circle = false,
  loading = "lazy",
  loadedCallback,
  ...props
}: ImageProps): JSX.Element {
  // Which source has settled, and how: a new `src` loads afresh, and one
  // that fails (an expired signed URL) stops the loading shimmer.
  const [settled, setSettled] = useState<{ src: string; ok: boolean } | null>(
    null,
  );
  const loaded = settled?.src === src && settled.ok;
  const failed = settled?.src === src && !settled.ok;

  return (
    <>
      {!loaded && (
        <Skeleton
          height={height}
          width={width}
          circle={circle}
          enableAnimation={!failed}
        />
      )}
      <img
        src={src}
        onLoad={() => {
          setSettled({ src, ok: true });
          loadedCallback?.();
        }}
        onError={() => setSettled({ src, ok: false })}
        alt={alt}
        id={id}
        className={className}
        style={{ display: loaded ? "block" : "none", ...style }}
        {...props}
      />
    </>
  );
}
